var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.106,
    height: 16.261,
    viewBox: "0 0 18.106 16.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161594",
    "data-name": "Group 161594",
    transform: "translate(-973.241 -634.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161592",
    "data-name": "Group 161592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-svgrepo-com",
    transform: "translate(970.991 631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M3,15.809V8.8a4.584,4.584,0,0,1,.2-1.945,1.845,1.845,0,0,1,.806-.806,4.584,4.584,0,0,1,1.945-.2h.973a2.071,2.071,0,0,0,.222-.006.923.923,0,0,0,.668-.413,2.072,2.072,0,0,0,.1-.2,4.143,4.143,0,0,1,.21-.393,1.845,1.845,0,0,1,1.336-.826A4.143,4.143,0,0,1,9.911,4H12.7a4.143,4.143,0,0,1,.445.012,1.845,1.845,0,0,1,1.336.826,4.165,4.165,0,0,1,.21.393,2.051,2.051,0,0,0,.1.2.923.923,0,0,0,.668.413,2.073,2.073,0,0,0,.223.006h.973a4.584,4.584,0,0,1,1.945.2,1.845,1.845,0,0,1,.806.806,4.584,4.584,0,0,1,.2,1.945v7.011a4.584,4.584,0,0,1-.2,1.945,1.845,1.845,0,0,1-.806.806,4.584,4.584,0,0,1-1.945.2H5.952a4.584,4.584,0,0,1-1.945-.2,1.845,1.845,0,0,1-.806-.806A4.584,4.584,0,0,1,3,15.809Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "camera-rotate-svgrepo-com_1_",
    "data-name": "camera-rotate-svgrepo-com (1)",
    d: "M5.372,15.029h.785A4.112,4.112,0,0,0,10.289,18.5a4.006,4.006,0,0,0,2.493-.854c.351-.274.442-.663.183-.938a.634.634,0,0,0-.892-.015,2.715,2.715,0,0,1-1.784.648,3.1,3.1,0,0,1-3.026-2.31h.785c.335,0,.427-.32.229-.587l-1.2-1.662a.433.433,0,0,0-.747,0L5.151,14.442C4.961,14.709,5.037,15.029,5.372,15.029Z",
    transform: "translate(972.137 628.882)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "camera-rotate-svgrepo-com_1_2",
    "data-name": "camera-rotate-svgrepo-com (1)",
    d: "M.323,2.463h.785A4.112,4.112,0,0,0,5.24,5.931a4.006,4.006,0,0,0,2.493-.854c.351-.274.442-.663.183-.938a.634.634,0,0,0-.892-.015,2.715,2.715,0,0,1-1.784.648,3.1,3.1,0,0,1-3.026-2.31H3c.335,0,.427-.32.229-.587L2.031.214a.433.433,0,0,0-.747,0L.1,1.876C-.088,2.143-.012,2.463.323,2.463Z",
    transform: "translate(987.403 644.561) rotate(180)",
    fill: "#0d0d0d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCameraIcon);
export default __webpack_public_path__ + "static/media/rotate-camera-icon.bf6c05c95cc33fac88c3ac495a9f4710.svg";
export { ForwardRef as ReactComponent };